import React from 'react';

import {useEffect, useState} from 'react';

import {fetchLaunchDarklyClientConfig} from '../../fetch-data/fetch-launch-darkly-config';
import {LoaderSpinner} from '@vw-marketing/us-components';
import {ThemeProvider} from '@volkswagen-onehub/components-core';
import LaunchDarklyProvider from '../../context/LaunchDarklyProvider';
import { App } from '../../App';

const AppWithLaunchDarkly: React.FC<{baseUrl?: string}> = ({baseUrl}) => {
  const [clientId, setClientId] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initLaunchDarkly = async () => {
      try {
        const ldKey = await fetchLaunchDarklyClientConfig(baseUrl);
        setClientId(ldKey);
      } catch (error) {
        console.error('Failed to fetch LaunchDarkly config:', error);
      } finally {
        setLoading(false);
      }
    };

    initLaunchDarkly();
  }, [baseUrl]);

  if (loading) {
    return (
      <ThemeProvider theme="main">
        <LoaderSpinner />
      </ThemeProvider>
    );
  }

  return (
    <LaunchDarklyProvider clientId={clientId}>
      <App baseUrl={baseUrl}/>
    </LaunchDarklyProvider>
  );
};

export default AppWithLaunchDarkly;
